import React, { useState } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './catalog.css';
import nanologo from '../../logo/nano.png';
import cultlogo from '../../logo/cult.png';
import mayalogo from '../../logo/maya.png';
import bemelogo from '../../logo/beme.png';
import salonlogo from '../../logo/salon.png';
import rabinsonlogo from '../../logo/robinson.png';
// import cultcatalog from 'http://dl.mahoganyacademy.de/catalog/cult.pdf';
// import mayacatalog from 'http://dl.mahoganyacademy.de/catalog/maya.pdf';
// import bemecatalog from 'http://dl.mahoganyacademy.de/catalog/beme.pdf';
// import nanocatalog from 'http://dl.mahoganyacademy.de/catalog/nano.pdf';
// import rabinsoncatalog from 'http://dl.mahoganyacademy.de/catalog/rabinson.pdf';
// import saloncatalog from 'http://dl.mahoganyacademy.de/catalog/salon.pdf';

export default function Catalog() {
    const [selectedCatalog, setSelectedCatalog] = useState(null);

    const catalogs = [
        { brand: "نانو", imageUrl: nanologo, pdfUrl: 'http://dl.mahoganyacademy.de/catalog/nano.pdf' },
        { brand: "کالت", imageUrl: cultlogo, pdfUrl: 'http://dl.mahoganyacademy.de/catalog/maya.pdf' },
        { brand: "مایا", imageUrl: mayalogo, pdfUrl: 'http://dl.mahoganyacademy.de/catalog/maya.pdf' },
        { brand: "بی می", imageUrl: bemelogo, pdfUrl: 'http://dl.mahoganyacademy.de/catalog/beme.pdf' },
        { brand: "رابینسون", imageUrl: rabinsonlogo, pdfUrl: 'http://dl.mahoganyacademy.de/catalog/rabinson.pdf' },
        { brand: "سالن فرمولا", imageUrl: salonlogo, pdfUrl: 'http://dl.mahoganyacademy.de/catalog/salon.pdf' },
    ];

    return (
        <div className='catalogpage'>
            <div className="catalog-list">
                {catalogs.map((catalog, index) => (
                    <div className="catalog-item" key={index}>
                        <img src={catalog.imageUrl} alt={`${catalog.brand} catalog`} className="catalog-image" />
                        <h3 className="catalog-brand">{catalog.brand}</h3>
                        {/* <button
                            className="view-button"
                            onClick={() => setSelectedCatalog(catalog.pdfUrl)}
                        >
                            مشاهده کاتالوگ
                        </button> */}
                        <a href={catalog.pdfUrl} download className="download-button">
                            دانلود و مشاهده کاتالوگ
                        </a>
                    </div>
                ))}
            </div>
            {selectedCatalog && (
                <div className="pdf-viewer-container">
                    <button className="close-button" onClick={() => setSelectedCatalog(null)}>
                        بستن
                    </button>
                    <Worker workerUrl={`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`}>
                        <Viewer fileUrl={selectedCatalog} />
                    </Worker>
                </div>
            )}
        </div>
    );
}
